module.exports = __webpack_public_path__ + "static/media/logo_TECMA_white.c7829759.svg";